export default "__VITE_ASSET__WNRWFhG2__"